import type { Components } from 'react-markdown'
import { MarkdownText } from 'ui-kit'
import Request from '@src/services/api/Request'
import { routePageHead } from '@src/utils/routeHead'
import type { CookiePolicyAttributes } from '@src/types/strapi'
import { createFileRoute } from '@tanstack/react-router'
import { Container } from '@mui/material'

const legalPageSx = {
  pb: 4,
  '& h1, & h2, & h3, & h4': { mt: 1.5, mb: 0, mx: 0 },
  '& a': { color: 'primary.light', textDecoration: 'underline' },
  '& li': { listStyle: 'decimal', ml: 3, my: 0, mr: 0 },
} as const

const legalTableComponents: Components = {
  table: ({ node: _node, ...props }) => (
    <table
      style={{ border: '0.5px solid black', borderSpacing: 0 }}
      {...props}
    />
  ),
  th: ({ node: _node, ...props }) => (
    <th
      style={{
        background: 'lightgray',
        border: '0.5px solid black',
        padding: '8px',
      }}
      {...props}
    />
  ),
  td: ({ node: _node, ...props }) => (
    <td style={{ border: '0.5px solid black', padding: '8px' }} {...props} />
  ),
}

export const Route = createFileRoute('/cookie-policy')({
  loader: async () => {
    const cookiePolicy = (await Request.cookiePolicy()) || {}
    return { cookiePolicy: cookiePolicy?.attributes ?? null }
  },
  staleTime: 60_000,
  head: ({ loaderData }) =>
    routePageHead(loaderData?.cookiePolicy?.seo?.pageTitle),
  component: CookiePolicyPage,
})

function CookiePolicyPage() {
  const { cookiePolicy } = Route.useLoaderData() as {
    cookiePolicy: CookiePolicyAttributes | null
  }

  return (
    <Container maxWidth="lg" sx={legalPageSx}>
      <MarkdownText allowHtml components={legalTableComponents}>
        {cookiePolicy?.cookiePolicy}
      </MarkdownText>
    </Container>
  )
}
